jQuery(document).ready(function(jQuery) {

    

  jQuery('#open_side--cart').on('click', function(){
		jQuery('#cart-sidebar').addClass('active');
		jQuery('body').append('<div class="menu_overlay_mobile" style="z-index:999;"></div>');
		jQuery("body").addClass('side-menu-open');
	});
	jQuery('#close_side--cart').on('click', function(){
		jQuery('#cart-sidebar').removeClass('active');
		jQuery('.menu_overlay_mobile').remove();
		jQuery("body").removeClass('side-menu-open');
	});

   jQuery(document).delegate(".menu_overlay_mobile", "click", function(e) {
        jQuery('#cart-sidebar').removeClass('active');
		jQuery('.menu_overlay_mobile').remove();
		jQuery("body").removeClass('side-menu-open');
   });

  

  jQuery(document).delegate(".add-to-cart", "click", function(e) {
    cart_sidebar_open();
    var form = jQuery(this).closest('form');
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      success: function() { 
        cart_sidebar_update();
      },
      error: function(xhr, text) {
        jQuery('.cart-sidebar-error-message').show();
        jQuery('.cart-sidebar-error-message').text(jQuery.parseJSON(xhr.responseText).description);
        cart_sidebar_update();
        jQuery('#cart-sidebar .cart-sidebar-loading').hide();
        
      
      }
    });
    e.preventDefault();
    
  });

  // jQuery('.buy--now').on('click',function(e){
  //   //clear_cart();
  //   var form = jQuery(this).closest('form');
  //   jQuery.ajax({
  //     type: 'POST',
  //     url: '/cart/add.js',
  //     data: form.serialize(),
  //     dataType: 'json',
  //     success: function(cart) { 
  //       window.location.href = '/checkout';
  //     },
  //     error: function(xhr, text) {
  //       jQuery('.cart-sidebar-error-message').show();
  //       jQuery('.cart-sidebar-error-message').text(jQuery.parseJSON(xhr.responseText).description);
  //       cart_sidebar_update();
  //       jQuery('#cart-sidebar .cart-sidebar-loading').hide();
      
  //     }
  //   });
  //   e.preventDefault();
    
  // });


  
  function cart_sidebar_open() {
    jQuery('#cart-sidebar').addClass("active");
    jQuery('#cart-sidebar').addClass("_loading");
    jQuery('#cart-sidebar').addClass('active');
	jQuery('body').append('<div class="menu_overlay_mobile" style="z-index:999;"></div>');
	jQuery("body").addClass('side-menu-open');
  };
  
  function cart_sidebar_update(){
      jQuery.getJSON('/cart.js', function(cart){
      cart_sidebar_update_mini_cart(cart);
      cart_sidebar_update_product(cart);
      cart_sidebar_update_totals(cart);
      jQuery('#cart-sidebar').removeClass("_loading");
      jQuery('#cart-sidebar').removeClass("is_empty");
        
        if (cart.item_count == 0) {
          jQuery('#cart-sidebar').addClass("is_empty");
        }
              
    });
  };
  
  function cart_sidebar_update_mini_cart(cart) {
    jQuery('.cart-count').text(cart.item_count);
  }
  
  function cart_sidebar_update_product(cart) {
    jQuery('.drawer__heading .drawer__count span').text(cart.item_count);


    var template ='<li class="__cart_sidebar_item __cart_sidebar_{ID} __cart_item_{PRODUCTID}" data-id="{ID}" data-key="{KEY}"><div class="cart-sidebar-product-image"><a href="{URL}"><img src="{IMAGE}" alt="{NAME}" height="55"/></a></div><div class="cart_product--details"><div class="cart_product--item"><div><a href="{URL}" class="cart-item__name">{NAME}</a><span class="cart_item--price">AED {PRICE}</span></div><div class="__product-qty"><input value="-" id="minus" class="qty_minus" type="button" fdprocessedid="{KEY}"><input type="number" id="productqty" step="1" min="1" name="quantity" data-id="{ID}" data-key="{KEY}" value="{QUANTITY}" title="Qty" class="input-text qty text cart_sidebar_qty" size="4" fdprocessedid="dcnsci"><input value="+" id="plus" class="qty_plus" type="button" fdprocessedid="{KEY}"></div></div><div class="cart-item__bottom"><p class="product-option">{OPTIONS}</p><div class="cart-sidebar-product-remove" data-id="{ID}" data-key="{KEY}"><span>Remove</span></div></div></div></li>';
      
     var ProductList = jQuery('.cart-sidebar-products ul');
    if (cart.item_count > 0) {
      var cru_hide = false;
      for(var i = 0; i < cart.items.length; i++) {
        if (i == 0) {
          ProductList.html('');
        }
        var item = template;

        var option_html = '';
        if(cart.items[i].options_with_values){
          for(var p = 0; p < cart.items[i].options_with_values.length; p++) {
               if(cart.items[i].options_with_values[p].value!="Default Title"){
                 option_html += cart.items[i].options_with_values[p].name+': '+cart.items[i].options_with_values[p].value+'<br/>';
               }
          }
        }


        
        item = item.replace(/\{ID\}/g, cart.items[i].id);
        item = item.replace(/\{KEY\}/g, cart.items[i].key);
        item = item.replace(/\{PRODUCTID\}/g, cart.items[i].product_id);
        item = item.replace(/\{INDEX\}/g, i);
        item = item.replace(/\{URL\}/g, cart.items[i].url);
        item = item.replace(/\{NAME\}/g, cart.items[i].product_title);  
        item = item.replace(/\{VARIANT\}/g, cart.items[i].variant_title || '');
        item = item.replace(/\{QUANTITY\}/g, cart.items[i].quantity);
        item = item.replace(/\{IMAGE\}/g, cart.items[i].image);
        item = item.replace(/\{OPTIONS\}/g, option_html);
        item = item.replace(/\{PRICE\}/g, cart.items[i].original_price / 100);
        item = item.replace(/\{MAX\}/g, 24);
        ProductList.append(item);

      }
      
      

    } else {
      ProductList.html('');
      jQuery('#cart-sidebar').addClass("is_empty");
    }
    
  
  }


  
  function cart_sidebar_update_totals(cart) {
   jQuery('.totals__subtotal-value span').html(Shopify.formatMoney(cart.total_price));
  }
  
  function cart_sidebar_update_quantity(itemKey,quantity){
    cart_sidebar_open();
    jQuery.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity='+quantity+'&id='+itemKey,
      dataType: 'json',
      success: function() { 
        cart_sidebar_update();
      },
      error: function(xhr, text) {
	    jQuery('.cart-sidebar-error-message').show();
        jQuery('.cart-sidebar-error-message').text(jQuery.parseJSON(xhr.responseText).description);
        cart_sidebar_update();
        jQuery('#cart-sidebar .cart-sidebar-loading').hide();

      }
    });
  }
  
  
  jQuery(document).delegate(".cart_sidebar_qty", "change", function(e) {
    var itemKey = jQuery(this).attr('data-key');
    var quantity = jQuery(this).val();
    cart_sidebar_update_quantity(itemKey,quantity);
   
  });
  
  
   jQuery(document).delegate(".cart-sidebar-product-remove", "click", function(e) {
    cart_sidebar_open();
    var itemKey = jQuery(this).attr('data-key');
    
    jQuery.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&id=' + itemKey,
      dataType: 'json',
      success: function() { 
        cart_sidebar_update();
      },
      error: function(xhr, text) {
        jQuery('.cart-sidebar-error-message').text(jQuery.parseJSON(xhr.responseText).description);
        jQuery('#cart-sidebar .cart-sidebar-loading').hide();    
      }
    });
    
    e.preventDefault();
    
  });


  

  jQuery('.swatch-option').on('click', function(){
     var type = jQuery(this).data("type");
     var value = jQuery(this).data("value");
     jQuery(this).closest('.swatch-attribute-options').children('.swatch-option').removeClass('selected');
     jQuery(this).addClass('selected');
     jQuery(this).closest('.swatch-attribute').children('.swatch-attribute-selected-option').text(jQuery(this).children('label').text());

      
   });

  























/* ---------- WARRANTY: Instant add/remove (StockMart) ---------- */
jQuery(document).ready(function($) {

  const warrantyVariant = 50641351541042; // <- your variant id
  const $checkbox = $(document).find('#warrantyCheckbox');

  if (!$checkbox.length) {
    console.warn('warrantyCheckbox not found in DOM');
    return;
  }

  // Disable/enable helper
  function setBusy(state) {
    $checkbox.prop('disabled', !!state);
  }

  // Sync checkbox with current cart on load
  function syncCheckboxWithCart() {
    $.getJSON('/cart.js', function(cart) {
      const found = cart.items.find(item => item.id == warrantyVariant);
      $checkbox.prop('checked', !!found);
    });
  }

  // Add warranty (form-encoded POST so it matches your theme)
  function addWarranty() {
    setBusy(true);
    if (typeof cart_sidebar_open === 'function') cart_sidebar_open();
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { id: warrantyVariant, quantity: 1 }, // form encoded
      dataType: 'json',
      success: function() {
        if (typeof cart_sidebar_update === 'function') cart_sidebar_update();
        setBusy(false);
      },
      error: function(xhr) {
        console.error('Warranty add error:', xhr);
        if (typeof cart_sidebar_update === 'function') cart_sidebar_update();
        setBusy(false);
      }
    });
  }

  // Remove warranty (find its key then change to qty 0)
  function removeWarranty() {
    setBusy(true);
    if (typeof cart_sidebar_open === 'function') cart_sidebar_open();
    $.getJSON('/cart.js', function(cart) {
      const found = cart.items.find(item => item.id == warrantyVariant);
      if (!found) {
        // nothing to remove
        if (typeof cart_sidebar_update === 'function') cart_sidebar_update();
        setBusy(false);
        return;
      }
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=0&id=' + found.key, // form encoded string
        dataType: 'json',
        success: function() {
          if (typeof cart_sidebar_update === 'function') cart_sidebar_update();
          setBusy(false);
        },
        error: function(xhr) {
          console.error('Warranty remove error:', xhr);
          if (typeof cart_sidebar_update === 'function') cart_sidebar_update();
          setBusy(false);
        }
      });
    }).fail(function() {
      // failed to read cart
      setBusy(false);
    });
  }

  // Prevent duplicate requests: ignore change while busy
  let localBusy = false;
  $checkbox.on('change', function() {
    if (localBusy) return;
    localBusy = true;
    // disable for UI safety
    setBusy(true);

    // re-check cart first to avoid double-adding
    $.getJSON('/cart.js', function(cart) {
      const present = cart.items.some(item => item.id == warrantyVariant);
      if ($checkbox.prop('checked')) {
        if (present) {
          // already present — just refresh UI
          if (typeof cart_sidebar_update === 'function') cart_sidebar_update();
          setBusy(false);
          localBusy = false;
        } else {
          addWarranty();
          localBusy = false;
        }
      } else {
        if (!present) {
          // not present — nothing to do
          if (typeof cart_sidebar_update === 'function') cart_sidebar_update();
          setBusy(false);
          localBusy = false;
        } else {
          removeWarranty();
          localBusy = false;
        }
      }
    }).fail(function() {
      console.error('Failed to read cart on checkbox change.');
      setBusy(false);
      localBusy = false;
    });
  });

  // initial sync
  syncCheckboxWithCart();

});


















  



  
});


   